<script>
import Card from "./Card";

export default {
  components: {
    Card
  },

  methods: {
    handleRedirect() {
      if (window.navigator.userAgent.toLowerCase().includes("iphone")) {
        window.open(
          "https://apps.apple.com/br/app/donamaid/id1519670575",
          "_blank"
        );
        return;
      }

      window.open(
        "https://play.google.com/store/apps/details?id=com.donamaid.donamaid",
        "_blank"
      );
    }
  }
};
</script>

<template>
  <Card
    header="Novo app Donamaid disponível"
    text="O novo app Donamaid para clientes já está disponível nas lojas de aplicativo do iOS e Android. Clique aqui para baixar ou atualizar o seu app."
    imagePath="/static/dashboard/app.svg"
    inverted
    gradient
    @onClick="handleRedirect"
  />
</template>



// WEBPACK FOOTER //
// src/components/Dashboard/components/InfoCards/cards/App.vue